export default function H1({ text }) {
  return <h1>{text}</h1>;
}
